import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { User, Password } from '../../../shared/user.model';
import swal from 'sweetalert2';
import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit {
  Id: any;
  mode: any;
  title = "Add User"
  data: any;
  roleId:string;
  officeList;
  roleList;
  projects;
  formSubmitted: boolean;
  user:any;
  password:Password;
  Clientlist;

  constructor(private userService: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) {
    this.user = new User();
    this.formSubmitted = false;
    this.Id=null;
    this.mode=null;
    this.user={};
  }

  ngOnInit() {
    // this.GetAllRoleNames();
    this.GetRolesforSelectedOffice();
    // this.GetProjectsforRoles();
    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.Id = params['Id'];
    });

    if(this.Id!=null || this.Id!=undefined)
     this.GetUserForTheId(this.Id);
  }



  GetUserForTheId(Id) {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getUserForTheId(Id)
      .subscribe(
        (data) => {
          this.user = data;
          this.roleId=this.user.RoleId;
          this.GetRolesforSelectedOffice();
          this.getClients(this.roleId);
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  getClients(RoleId) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getClients(RoleId)
      .subscribe(
        (data:any) => {
          this.Clientlist = data;
          // this.roleId=this.user.RoleId;
          // this.GetRolesforSelectedOffice();
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  // GetAllRoleNames() {
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetAllRoleNames();
  //   this.data.subscribe(
  //     (response) => {
  //       this.officeList = response;
  //       document.getElementById('loader-spinner').style.display = "none";
  //       if (this.Id != null && this.mode!=null) 
  //         this.GetUserForTheId(this.Id);
  //     }, (error) => {
  //       document.getElementById('loader-spinner').style.display = "none";
  //       this.errorHandler.HandlerError(error);
  //     });
  // }

  GetRolesforSelectedOffice() {
    debugger;
    // if (this.user != null) {
    //   this.user.RoleId=undefined;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.getRolesforSelectedOffice();
      this.data.subscribe(
        (response) => {
          this.roleList = response;
          // if(this.mode!=null)
          //   this.user.RoleId=this.roleId;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    // }
  }
  // GetProjectsforRoles() {
  //   debugger;
  //   // if (this.user != null) {
  //   //   this.user.RoleId=undefined;
  //     document.getElementById('loader-spinner').style.display = "block";
  //     this.data = this.userService.GetProjectsforRoles();
  //     this.data.subscribe(
  //       (response) => {
  //         this.projects = response;
  //         // if(this.mode!=null)
  //         //   this.user.RoleId=this.roleId;
  //         document.getElementById('loader-spinner').style.display = "none";
  //       }, (error) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //         this.errorHandler.HandlerError(error);
  //       });
  //   // }
  // }

  onSubmit(form: NgForm) {
    if (!form.invalid) {
    document.getElementById('loader-spinner').style.display = "block";
    console.log(form.value);
    this.data = this.userService.registerUser(form.value);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Saved Successfully!','success');
         this.router.navigate(['/home/userlist']);
        form.resetForm();
        form.reset();
        }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        //this.errorHandler.HandlerError(error);
        swal('Warning!', error.error.Message, 'warning');
      });
  }else
  this.formSubmitted = true;
}

update(form: NgForm) {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.changePasswordForTheId(form.value)
    .subscribe(
      (data) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','updated Successfully!','success');
        this.router.navigate(['/home/userlist']);
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });

}

}




// WEBPACK FOOTER //
// ./src/app/ultilities/user/user-form/user-form.component.ts